<template>
  <simple-expansion-card 
    :style="{width: '100%'}"
    active-classes=""
  >
    <template #title>
      <div :style="{display: 'flex', 'align-items': 'baseline'}">
        Floor Summary
        <scaler 
          v-if="runTime"
          y-axis="0.7"
        >
          <template v-slot="{fontSize}">
            <div :style="{fontSize}">
              <div class="pl-1">
                (Updated at {{ runTime }})
              </div>
            </div>
          </template>
        </scaler>
      </div>
    </template>
    <template #title-right="{ open }">
      <v-fade-transition>
        <v-btn
          v-if="open"
          icon
          @click.stop="runReports"
        >
          <v-icon class="black--text">
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-fade-transition>
    </template>
    <api-errors v-bind="{errors}" />
    <v-fade-transition
      hide-on-leave
      group
    >
      <loading-bar 
        v-if="awaitingApiResponse" 
        key="loading-bar"
      />
      <v-row 
        v-else
        key="data-points"
        no-gutters
      >
        <v-col
          v-for="(report, i) of reports"
          :key="`report-${i}`"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <data-card v-bind="report">
            <div class="d-flex flex-column">
              <div
                v-for="(line, j) of report.text || []"
                :key="`report-${i}-line-${j}`"
                :style="report.styles[j] || {}"
                v-html="line"
              />
            </div>
          </data-card>
        </v-col>
      </v-row>
    </v-fade-transition>
  </simple-expansion-card>
</template>

<script>
import floorPlanHelpers from './mixins/floorPlanHelpers'
import DataCard from './helperComponents/DataCard'
import Scaler from '@/ft-vue-core/components/transformers/Scaler'
export default {
  name: 'FloorPlanDataFooter',
  components: {DataCard, Scaler},
  mixins: [floorPlanHelpers],
  props: {
    eventId: Number,
    mealPeriodId: Number,
    tableConfigurationId: Number,
  },
  data () {
    return {
      runTime: undefined,
      reports: [],
    }
  },
  mounted () {
    ['mealPeriodId', 'tableConfigurationId'].forEach(w => this.$watch(w, this.runReports))
    this.runReports()
  },
  methods: {
    /**
     * Defer to backend to run all reports and get new `runTime` timestamp
     * @see runTime @see reports
     */
    runReports () {
      const {tableConfigurationId, mealPeriodId, eventId} = this.$props
      if (!(tableConfigurationId && (mealPeriodId || eventId))) return
      this.awaitingApiResponse = true
      this.$ftAPI().get({
        command: 'diningRunFloorPlanReports',
        afterLoad: (resp) => {
          this.awaitingApiResponse = false
          const [r] = resp ?? [{}]
          this.runTime = r.runTime
          this.reports = r.result
        },
        error: e => {
          this.awaitingApiResponse = false
          this.errors.push(e.message)
        },
        params: {
          filter_methods: this.eventId != null
            ? {filterEventData: [tableConfigurationId, eventId]}
            : {filterData: [tableConfigurationId, mealPeriodId]}
        }
      })
    }
  }
}
</script>